import { isEmpty } from 'lodash';

import {
  hasInvalidBackupsInSection,
  hasInvalidOrDuplicateDate,
} from '../../ScheduleComponentPage.helper';
import {
  IDefaultSection,
  IGridSection,
  IScheduledSectionComponent,
} from '../../ScheduleComponentPage.interface';

export const validateScreenStatus = (
  section: IGridSection | IDefaultSection,
  isAbleToEditSection?: (
    components: IScheduledSectionComponent[] | undefined,
  ) => boolean,
  isOwnerOperator?: boolean,
) => {
  const hasComponents = !isEmpty(section.components);
  const hasComponentsSectionWithoutStartDate = hasInvalidOrDuplicateDate(
    section?.components || [],
    isOwnerOperator,
  );

  const hasOverrideDateRange = section?.components?.some(
    (component) =>
      component.override?.start_date && component.override?.end_date,
  );

  const enabledScheduleButton = isAbleToEditSection
    ? isAbleToEditSection(section?.components)
    : !!(section?.canBeScheduled || section?.canBeDeleted);

  const showWarningIcon =
    (hasComponents && hasComponentsSectionWithoutStartDate) ||
    hasInvalidBackupsInSection(section);

  const showCheckIcon =
    hasComponents &&
    !hasComponentsSectionWithoutStartDate &&
    !hasInvalidBackupsInSection(section);

  return {
    hasComponents,
    enabledScheduleButton,
    showWarningIcon,
    showCheckIcon,
    hasOverrideDateRange,
  };
};
